import React from "react";
import PropTypes from "prop-types";
import CommonDataTable from "../../../components/Datatable/CommonDataTable";
import CommonDropdown from "../../../components/dropdown/CommonDropdown";
import DropdownButton from "../../../components/dropdown/DropdownButton";

function SuporteDataTable({
  linhas,
  togVisualizarTicketModal,
  concluirTicket,
  isFechado,
}) {
  const colunas = React.useMemo(
    () => [
      {
        Header: "ID",
        accessor: "id",
      },
      {
        Header: "Módulo",
        accessor: "modulo",
      },
      {
        Header: "Solicitante",
        accessor: "solicitante",
      },
      {
        Header: "Responsável",
        accessor: "responsavel",
      },
      {
        Header: "Ações",
        disableSortBy: true,
        Cell: ({ row }) => (
          <CommonDropdown>
            <DropdownButton
              key={`visualizar-${row.original.id}`}
              onClick={() =>
                togVisualizarTicketModal(row.original.id, isFechado)
              }
              icon="mdi mdi-file-search"
              color="primary"
              aria-label="Visualizar ticket"
            >
              Visualizar
            </DropdownButton>
            {!isFechado && (
              <DropdownButton
                key={`concluir-${row.original.id}`}
                onClick={() => concluirTicket(row.original.id)}
                icon="mdi mdi-checkbox-marked"
                color="success"
                aria-label="Concluir ticket"
              >
                Concluir
              </DropdownButton>
            )}
          </CommonDropdown>
        ),
      },
    ],
    [concluirTicket, togVisualizarTicketModal, isFechado]
  );

  return <CommonDataTable colunas={colunas} linhas={linhas} />;
}

SuporteDataTable.propTypes = {
  linhas: PropTypes.array.isRequired,
  togVisualizarTicketModal: PropTypes.func.isRequired,
  concluirTicket: PropTypes.func,
  isFechado: PropTypes.bool.isRequired,
  row: PropTypes.object,
};

const SuporteDataTables = {
  Abertos: (props) => <SuporteDataTable {...props} isFechado={false} />,
  Fechados: (props) => <SuporteDataTable {...props} isFechado={true} />,
};

export default SuporteDataTables;
